// extracted by mini-css-extract-plugin
export default {"hero":"Home_hero__auOa5","heroContainer":"Home_heroContainer__AdSwn","text":"Home_text__J90QS"};